import React from 'react';
import DynamicTable from '../tables/DynamicTable';

interface WerkveldBoxProps {
    title: string;
    project: any;
}

const WerkveldBox = ({ title, project } : WerkveldBoxProps) => {
    return (
        <div>
            <div className='box'>
                <h3>Doelgroep: Voor wie?</h3>
                <DynamicTable
                data={project?.targetAudiences?.models}
                columns={[
                    {id: 2 ,label: "Type", property:'type.name'},
                    {id: 3 ,label: "Subtype", property:'subType.name'},
                    {id: 4 ,label: "Description", property:'description'},
                ]}
                />
            </div>
            <div className='box'>
                <h3>Doelstellingen: Vraag of nood - Advies - Verwachting impact - Resultaat voor hogeschool</h3>
                    <DynamicTable
                    data={project?.goals?.models}
                    columns={[
                        {id: 2 ,label: "Aard", property:'kind.name'},
                        {id: 5 ,label: "Type", property:'type.name'},
                        {id: 3 ,label: "Subtype", property:'subType.name'},
                        {id: 4 ,label: "Start Datum", property:'startDate'},
                        {id: 6 ,label: "Description", property:'description'},
                    ]}
                    />
            </div>
        </div>
    );
};

export default WerkveldBox;
